export default {
  createOrders: 'orders:create',

  // Able to delete users, change user roles, and invite users with specific role
  manageUsers: 'users:manage',

  // Able to invite users that will recieve the same role they have
  inviteUsers: 'users:invite',

  viewInvoices: 'invoices:view',
  invoicesPaymentStatus: 'invoices:paymentStatus',

  // Able to see who placed an order (staged order user / dispatch set contact)
  viewOrderedBy: 'stagedOrder:viewOrderedBy',
};
